import { Component, OnInit } from '@angular/core';
import {TableSelectionAbstract} from '../../../../../shared/component/table/table-selection.abstract';
import {GeneralService} from '../../../../../service/general-service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NotificationService} from '../../../../../service/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from '../../../../../../app-config.service';
import {FormBuilder} from '@angular/forms';
import {Constant} from '../../../../../shared/constants/constant.class';

@Component({
  selector: 'app-export-machine',
  templateUrl: './export-machine.component.html',
  styleUrls: ['./export-machine.component.scss']
})
export class ExportMachineComponent extends TableSelectionAbstract implements OnInit {
  datas: any[] = [];
  data: any;
  loading: any;
  page: any;
  pageSize: any;
  defaultPage: any;
  checkDelete = true;
  checkUpdate = true;
  checkDetails = true;
  isVisibleAdd: boolean;
  enableEdit: boolean;
  searchText: any;
  checkAdd = true;
  chemicals: any[] = [];
  machines: any[] = [];
  filterData: any[];
  detailItems: any[];
  selectedData: any;
  scanBarcodeDefault: boolean;
  isEdit: boolean;
  viewOnly: boolean;
  loadingButton: boolean;
  activeScan: boolean;
  filter: any = {};
  selectedWarehouseId: any;
  constructor(
    private generalService: GeneralService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private configService: AppConfigService,
    private fb: FormBuilder,
  ) {
    super('id');
    this.detailItems = [];
    this.enableEdit = true;
    this.scanBarcodeDefault = true;
    this.selectedData = {
      id: 0,
      code: '',
      description: '',
      receiveType: 1,
      recipient: '',
      warehouseExportDetails: [],
      scanBarcode: this.scanBarcodeDefault
    };
    this.filter = {
      receiveType: 1,
      recipient: null,
      chemicalName: null,
      page: 1,
      pageSize: 100,
      fromWareHouseId: this.selectedWarehouseId
    };
  }

  ngOnInit(): void {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.filter.fromWareHouseId = this.selectedWarehouseId;
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getCheckedIdList();
    this.getMachine();
    this.getChemicalsList();
    this.getListData();
    this.activeScan = true;

  }

  getListData() {
    setTimeout(() => {
      this.loading = true;
      // this.filter = {};
      this.generalService.getWarehouseExport(this.filter).subscribe(res => {
        if (res !== null) {
          this.datas = res.data;
          this.filterData = res.data;
          this.loading = false;
          super.setListOfAllData(this.datas);
        }
        console.log('kho hoa chat', res);
      }, error => {

      });
    }, 50);
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe(data => {
      this.data = data;
    });
  }

  getChemicalsList() {
    this.generalService.getChemical().subscribe(res => {
      if (res !== null) {
        this.chemicals = res;
      }
    }, error => {

    });
  }
  getMachine() {
    this.generalService.getMachine().subscribe(res => {
      if (res !== null) {
        this.machines = res;
      }
    }, error => {

    });
  }

  showModalAdd() {
    this.viewOnly = false;
    this.isVisibleAdd = true;
    this.selectedData = {
      id: 0,
      code: '',
      description: '',
      receiveType: 1,
      recipient: '',
      warehouseExportDetails: [],
      scanBarcode: this.scanBarcodeDefault,
      parcelDetailCode: ''
    };
  }

  addDetailInput() {
    const item = {
      id: 0,
      chemicalId: 0,
      amount: 0,
      price: 0,
      totalPrice: 0,
      lotNumber: '',
      expiredDate: new Date(),
    };
    this.selectedData.warehouseExportDetails.push(item);
  }

  doSearch() {
  }

  showModalUpdate(data) {
    this.isEdit = true;
    this.viewOnly = false;
    this.selectedData = data;
    this.selectedData.scanBarcode = this.scanBarcodeDefault;
    this.isVisibleAdd = true;
  }

  handleOk() {

    console.log(this.selectedData);
    if (!this.selectedData.description){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa nhập mô tả phiếu');
      return;
    }
    if (!this.selectedData.receiveType){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa chọn đối tượng nhận');
      return;
    }
    if (!this.selectedData.recipient){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa nhập tên đối tượng');
      return;
    }
    if (!this.selectedData.warehouseExportDetails.length){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa nhập chi tiết phiếu xuất');
      return;
    }
    this.isVisibleAdd = false;
    this.loadingButton = true;
    this.generalService.addWarehouseExport(this.selectedData).subscribe(res => {
      this.loadingButton = false;
      console.log(res);
      if (res.ret && res.ret[0].code !== 0) {
        this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
      }
      else{
        this.isVisibleAdd = false;
        this.notificationService.showNotification(Constant.SUCCESS, 'Tạo phiếu xuất kho thành công');
        this.getListData();
      }
    }, error => {

    });
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: 'Confirm',
      nzContent: 'Bạn có muốn xóa hay không?',
      nzOkText: 'Đồng ý',
      nzCancelText: 'Bỏ qua',
      nzOnOk: () => this.deleteItem(id)
    });
  }

  deleteItem(id) {
    this.notificationService.showNotification(Constant.WARNING, 'Chức năng đang hoàn thiện');
    /*this.generalService.deleteWarehouseChemical(id).subscribe(res => {
      this.notificationService.showNotification(Constant.SUCCESS, Constant.MESSAGE_DELETE_SUCCESS);
      this.getListData();
    }, error => {

    });*/
  }

  deleteDetail($item) {
    this.selectedData.warehouseExportDetails = this.selectedData.warehouseExportDetails.filter(en => en.parcelDetailCode !== $item.parcelDetailCode);
  }

  showDetails(data) {
    this.selectedData = data;
    this.isVisibleAdd = true;
    this.viewOnly = true;
  }

  handleCancel() {
    this.isVisibleAdd = false;
  }

  getRowIndex = (index, pageIndex, pageSize) => index + 1 + pageSize * (pageIndex - 1);

  handleBarcode($event: any) {
    /*const existsItem = this.selectedData.warehouseExportDetails.find(en => en.parcelDetailCode === $event);
    if (existsItem){
      this.notificationService.showNotification(Constant.ERROR, 'Hóa chất đã được nhập vào chi tiết phiếu');
      return;
    }*/
    if ($event.length !== 8) {
      return;
    }
    if (!this.selectedData.recipient){
      this.notificationService.showNotification(Constant.ERROR, 'Chưa chọn máy XN');
      return;
    }
    this.loading = true;
    this.generalService.getChemicalByBarCode($event).subscribe(res => {
      console.log(res);
      if (res.ret && res.ret[0].code !== 0) {
        this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
        this.loading = false;
        this.selectedData.parcelDetailCode = '';
        this.activeScan = true;
      }
      else {
        this.selectedData = {
          id: 0,
          code: '',
          description: `Xuất hóa chất ${res.chemical.name} cho máy ${this.selectedData.recipient}`,
          receiveType: 1,
          recipient: this.selectedData.recipient,
          warehouseExportDetails: [res],
          scanBarcode: this.scanBarcodeDefault,
          fromWareHouseId: this.selectedWarehouseId
        };
        this.generalService.addWarehouseExport(this.selectedData).subscribe(resOK => {
          this.loadingButton = false;
          console.log(resOK);
          if (resOK.ret && resOK.ret[0].code !== 0) {
            this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
            this.loading = false;
          }
          else{
            this.isVisibleAdd = false;
            this.notificationService.showNotification(Constant.SUCCESS, `Xuất hóa chất ${res.chemical.name} cho máy ${this.selectedData.recipient} thành công`);
            this.getListData();
          }
        }, error => {

        });
        this.selectedData.parcelDetailCode = '';
        this.selectedData.warehouseExportDetails = [];
      }
    }, error => {

    });
  }
  leaveScanBarcode(): void{
    this.activeScan = false;
  }
  toggleScanBarcode(isActive){
    this.activeScan = isActive;
    if (isActive){
      setTimeout(() => {
        document.getElementById('txtBarcode').focus();
        console.log('focus');
      }, 200);

    }
    else{
    }
  }
  changeMachine($event: any) {
    setTimeout(() => {
      document.getElementById('txtBarcode').focus();
      console.log('focus');
    }, 200);
  }
  exportPDF() {
    const phieuId = this.selectedData.id;
    const mainUrl = this.configService.getConfig().api.reportUrl + '/BridgeXLSDownload.aspx';
    const url = mainUrl + `?PhieuId=${phieuId}&report=PhieuXuatKho`;
    console.log(url);
    window.open(url, '_blank');
  }
}
